import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault(dayjs.tz.guess())
// 获取当前时区和零时区的偏移量，单位是分钟
let localTimezoneMinutes = dayjs().utcOffset()

// 获取当前时区时间
export const getCurrentTime = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if(date) {
    let zoneTime = dayjs(date).add(localTimezoneMinutes, 'minute').format(format)
    return zoneTime === 'Invalid Date' ? '' : zoneTime
  } else {
    return ''
  }
}

// 当前时间转为UTC时间
export const getUTCTime = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if(date) {
    let utcTime = dayjs(date).utc().format(format)
    return utcTime === 'Invalid Date' ? '' : utcTime
  } else {
    return ''
  }
}

// 获取时间戳
export const getUTC = date => dayjs(date).utc()

// 获取当前时区
export const getCurrentTimeZone = () => {
  return dayjs.tz.guess()
}